export default "__VITE_ASSET__DSSml25h__"